/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Patient/view.blocks to change it.
import React from 'react'
import Search from './Search/index'
import Term from './Term/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Patient({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/ReferralsSection/Add/Content/Templates/Content/Referral/Value/Search/Patient"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Patient.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Patient.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<Term
  viewPath={`${viewPath}/Term`}
/>
</div>
</div>
<Search
  viewPath={`${viewPath}/Search`}
/>
{children}
</React.Fragment>)
}